// extracted by mini-css-extract-plugin
export var equalColumn = "_gx-0";